import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Modal } from 'bootstrap';
import AddUserModal from './addUserModal';
import users from "./users.json";
import EditUserModal from './editUserModal.jsx';
import userDetailsStyles from "../../../styles/userDetails/userDetails.module.css";
import branchManagerStyles from "../../../styles/branchManager/branchManager.module.css";
import Loader from '../../loader/index.js';
import UserDetailsClient from "../../../utility/features/api_clients/userDetails/userDetailsClient.js";


export default function UserDetails({ title = 'User details' }) {

    const [editUserDetails, setEditUserDetails] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [totalUsers, setTotalUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isUserAdded, setIsUserAdded] = useState(false);
    const [isUserEdited, setIsUserEdited] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(totalUsers?.length / ITEMS_PER_PAGE);
    const startIndex = (activePage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedUsers = totalUsers?.slice(startIndex, endIndex);
    const leadSuccessModalRef = useRef(null);
    const leadFailureModalRef = useRef(null);

    useEffect(() => {
        setLoading(true);
        const getUserDetails = async () => {
            try {
                const resp = await UserDetailsClient();
                if (resp.status === 200) {
                    setTotalUsers(resp.data);
                }
            } catch (err) {
                console.log("Error fetching user details:", err);
            }
            setLoading(false);
        }
        getUserDetails();
    }, [isUserAdded, isUserEdited]);


    const handleClickEdit = (user) => {
        setEditUserDetails(user);
    }

    const handlePageClick = (pageNum) => {
        setActivePage(pageNum);
    };

   const openSuccessModal = () => {
     if (leadSuccessModalRef.current) { 
        const instance = Modal.getOrCreateInstance(leadSuccessModalRef.current); 
        instance.show(); 
        } 
    };

   const openFailureModal = () => {
     if (leadFailureModalRef.current) { 
        const instance = Modal.getOrCreateInstance(leadFailureModalRef.current); 
        instance.show(); 
        } 
    };

    return (
        <div className="container py-4 pl-0 pr-0">
            <div className="row mb-3">
                <div className="col-6">
                    <h3>{title}</h3>
                </div>
                <div className="col-6" style={{textAlign:'end'}}>
                         <button
                        type="button"
                        className={`btn btn-info  ${userDetailsStyles["bg-green"]}`}
                       data-bs-toggle="modal"
                            data-bs-target="#addUserModal"
                    >
                         Add New User
                    </button>
                </div>
            </div>


            {loading ? <Loader /> :
                <>
                    <div className={branchManagerStyles["table-theme"]}>
                        <div className={`table-responsive ${branchManagerStyles["table-card"]}`}>
                            <table className={`w-100 ${branchManagerStyles["table"]} align-middle`}>
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">User Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">User Role</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedUsers.map((user) => {
                                        return <tr key={user.userID}>
                                            <td>{user.firstName}&nbsp;{user.lastName}</td>
                                            <td>{user.userName}</td>
                                            <td>{user.email}</td>
                                            <td>{user.roleName}</td>
                                            <td className={user.isActive === true ? "text-success" : "text-danger"}>
                                                {user.isActive === true ? "Active" : "In Active"}
                                            </td>
                                            <td>
                                                <button className={`btn btn-sm btn-outline-success rounded-pill py-1 px-3`} type="button"
                                                    data-bs-toggle="modal" data-bs-target="#editUserModal" onClick={() => handleClickEdit(user)}>
                                                    Edit
                                                </button>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {totalPages > 1 && (
                        <div className={userDetailsStyles['pagination-wrapper']}>
                            <div className={userDetailsStyles['pagination']}>
                                <button 
                                    className={`${userDetailsStyles["page-btn"]} ${userDetailsStyles['nav-btn']}`} 
                                    onClick={() => handlePageClick(activePage - 1)}
                                    disabled={activePage === 1}
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>

                                {activePage > 3 && (
                                    <>
                                        <button className={userDetailsStyles["page-btn"]} onClick={() => handlePageClick(1)}>1</button>
                                        {activePage > 4 && <span className={userDetailsStyles["ellipsis"]}>...</span>}
                                    </>
                                )}

                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter((num) => num >= activePage - 2 && num <= activePage + 2)
                                    .map((num) => (
                                        <button 
                                            key={num} 
                                            className={`${userDetailsStyles["page-btn"]} ${num === activePage ? userDetailsStyles["active"] : ""}`} 
                                            onClick={() => handlePageClick(num)}
                                        >
                                            {num}
                                        </button>
                                    ))}

                                {activePage < totalPages - 2 && (
                                    <>
                                        {activePage < totalPages - 3 && <span className={userDetailsStyles["ellipsis"]}>...</span>}
                                        <button className={userDetailsStyles["page-btn"]} onClick={() => handlePageClick(totalPages)}>{totalPages}</button>
                                    </>
                                )}

                                <button 
                                    className={`${userDetailsStyles["page-btn"]} ${userDetailsStyles['nav-btn']}`} 
                                    onClick={() => handlePageClick(activePage + 1)}
                                    disabled={activePage === totalPages}
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>

                            <div className={userDetailsStyles['pagination-info']}>
                                <span>Showing {startIndex + 1} - {Math.min(endIndex, totalUsers?.length)} of {totalUsers?.length} users</span>
                            </div>
                        </div>
                    )}</>
            }

            <AddUserModal setIsUserAdded={setIsUserAdded} leadSuccessModalRef={leadSuccessModalRef} 
            leadFailureModalRef={leadFailureModalRef} setLoading={setLoading} 
            setSuccessMessage={setSuccessMessage} setErrorMessage={setErrorMessage}
            openSuccessModal={openSuccessModal} openFailureModal={openFailureModal}
            />
            <EditUserModal userDetails={editUserDetails} setIsUserEdited={setIsUserEdited} 
            leadSuccessModalRef={leadSuccessModalRef} leadFailureModalRef={leadFailureModalRef} 
            setLoading={setLoading}  setSuccessMessage={setSuccessMessage} setErrorMessage={setErrorMessage}
            openSuccessModal={openSuccessModal} openFailureModal={openFailureModal}
            />
            {/** Success modal */}
            {/* <div ref={leadSuccessModalRef} className={`modal fade ${userDetailsStyles["userDetailsModal"]}`} id="leadSuccessModal" data-backdrop="static" data-keyboard="false">
                <div className={`modal-dialog modal-lg ${userDetailsStyles["modal-dialog"]}`}>
                    <div className={`modal-content ${userDetailsStyles["modal-content"]}`}>
                        <div className={`modal-header ${userDetailsStyles["modal-header"]}`}>
                            <h4 className={`modal-title ${userDetailsStyles["modal-title"]} ${userDetailsStyles["donex"]}`}>{successMessage}</h4>
                            <button type="button" className={`btn-close ${userDetailsStyles["btn-close"]}`} data-dismiss="modal"  data-bs-dismiss="modal" ></button>
                        </div>
                        <div className={`modal-body ${userDetailsStyles["modal-body"]}`}>
                            <form className={`${userDetailsStyles["success-lead-form"]}`} noValidate="" id="leadSuccessForm" name="leadSuccessForm">
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <button type="button" id="btnDone" data-dismiss="modal" data-bs-dismiss="modal" > Done</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div> */}

            {/** Failure modal */}

            {/* <div ref={leadFailureModalRef} className={`modal fade ${userDetailsStyles["userDetailsModal"]}`} id="leadFailureModal" data-backdrop="static" data-keyboard="false">
                <div className={`modal-dialog modal-lg ${userDetailsStyles["modal-dialog"]}`}>
                    <div className={`modal-content ${userDetailsStyles["modal-content"]}`}>
                        <div className={`modal-header ${userDetailsStyles["modal-header"]}`}>
                            <h4 className={`modal-title ${userDetailsStyles["modal-title"]} ${userDetailsStyles["donex"]}`}>Error adding user!</h4>
                            <button type="button" className={`btn-close ${userDetailsStyles["btn-close"]}`} data-dismiss="modal"  data-bs-dismiss="modal" ></button>
                        </div>
                        <div className={`modal-body ${userDetailsStyles["modal-body"]}`}>
                            <div className={`${userDetailsStyles["donexx"]}`}>
                                <p>{errorMessage || "Error adding user"}</p>
                            </div>
                            <form className={`${userDetailsStyles["success-lead-form"]}`} noValidate="" id="leadSuccessForm" name="leadSuccessForm">
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <button type="button" id="btnDone" data-dismiss="modal" data-bs-dismiss="modal" > Done</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
}



